import { render, staticRenderFns } from "./TedsLauncherNotifications.vue?vue&type=template&id=286df41c&scoped=true&"
import script from "./TedsLauncherNotifications.vue?vue&type=script&lang=ts&"
export * from "./TedsLauncherNotifications.vue?vue&type=script&lang=ts&"
import style0 from "./TedsLauncherNotifications.vue?vue&type=style&index=0&id=286df41c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286df41c",
  null
  
)

export default component.exports